/**
 * Model interfaces for the Review and Publish page
 */
import { PlanStatus } from '../../utils/constants';


export interface PrimaryGradingVolumeData {
    recommended: VolumeBreakdown;
    override: VolumeBreakdown;
}

export interface VolumeBreakdown {
    total: number;
    alps: number;
}

export interface OverrideMetrics {
    total: number;
    average: number;
}

export interface BacklogProjections {
    endOfShift: VolumeBreakdown;
    endOfWeek: VolumeBreakdown;
}

export interface ActualVsRecommended {
    actual: number;
    recommended: number;
}

export interface SimpleIntValue {
    intValue: number;
}

export interface EnhancedShiftTotals {
    headcount: ActualVsRecommended
    hours: ActualVsRecommended
    problemSolveVolume: SimpleIntValue
    amazonResaleVolume: SimpleIntValue
    vetAcceptedHours: SimpleIntValue
    vtoAcceptedHours: SimpleIntValue
    amazonReadyAcceptedHours: SimpleIntValue
    showHoursNeeded: SimpleIntValue
}

export interface ShiftNote {
    note: string;
}

export interface ShiftTimelineEvent {
    label: string;
    startTime: string;
    endTime?: string;
}

export interface ShiftSummaryCategory {
    heading: string;
    planOutput: ShiftSummaryData[];
}

export interface ShiftSummaryData {
    startTime: string;
    endTime: string;
    data: DataEntry[];
}

export interface DataEntry {
    label: string;
    intValue: number;
    hoursRequired?: number;
}

export interface ProjectedVolumeDataPoint {
    time: string;    
    recommended: number;
}

export interface GetShiftPlanOutputRequest {
    planId: string;
    date: string;
    warehouseId: string;
    shiftType: string;
}

export interface GetShiftPlanOutputResponse {
    planId: string;
    planStatus: PlanStatus;
    primaryGradingVolume: PrimaryGradingVolumeData;
    projectedPrimaryGradingVolume: ProjectedVolumeDataPoint[]; // Hourly projected volume data
    overrides: OverrideMetrics;
    backlogProjections: BacklogProjections;
    shiftTotals: EnhancedShiftTotals;
    shiftNotes: ShiftNote[];
    shiftTimeline: ShiftTimelineEvent[];
    shiftSummary: ShiftSummaryCategory[];
}

export const buildGetShiftPlanOutputRequest = (
    planId: string, date: string, warehouseId: string, shiftType: string
): GetShiftPlanOutputRequest => {
    return {
        planId, date, warehouseId, shiftType
    }
}
